import { MenuItem, Text } from "@chakra-ui/react"
import PropTypes from "prop-types"
import { getArchivedArticleDownloadZipUrl } from "../../../../../../common/hooks/queries"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import useModal from "../../../../../../common/hooks/useModal"
import DownloadZipModal from "../../../../../shared/DownloadZipModal"
import { C3dData } from "../../../../../shared/Icons"

const DownloadCadDrawingsMenuItem = ({
  availableZipOptionsFormData,
  zipCadDrawingsLink,
  setIsModalOpenFromMenu,
  isArchived,
}) => {
  const { t } = useBrandedTranslation()
  const { Modal, onOpen, onClose } = useModal()

  const handleOpen = () => {
    setIsModalOpenFromMenu(true)
    onOpen()
  }

  const handleClose = () => {
    setIsModalOpenFromMenu(false)
    onClose()
  }

  // Guard clause if we don't have zip files available for download
  if (!zipCadDrawingsLink) return null

  // Change download zip url if article is archived
  const getDownloadZipUrl = isArchived ? getArchivedArticleDownloadZipUrl : null

  return (
    <>
      <MenuItem icon={<C3dData />} onClick={handleOpen} aria-label="Open modal to select files for download">
        <Text fontWeight="medium">{t("pdp-article-more-cad")}</Text>
      </MenuItem>

      <DownloadZipModal
        Modal={Modal}
        title={t("pdp-downloadData-cadDrawings")}
        handleClose={handleClose}
        availableZipOptions={availableZipOptionsFormData}
        itemId={zipCadDrawingsLink}
        getDownloadZipUrl={getDownloadZipUrl}
      />
    </>
  )
}

export default DownloadCadDrawingsMenuItem

DownloadCadDrawingsMenuItem.propTypes = {
  availableZipOptionsFormData: PropTypes.object,
  zipCadDrawingsLink: PropTypes.string,
  setIsModalOpenFromMenu: PropTypes.func,
  isArchived: PropTypes.bool,
}
